import FaqBlockTab from './FaqBlockTab'

export default FaqBlockTab
